"use client";

interface ContactMessageDetailsSectionProps {
  title?: string;
  body?: string;
  listTitle?: string;
  items?: string[];
}

export default function ContactMessageDetailsSection({
  title = "What to Include in Your Message",
  body,
  listTitle,
  items = [],
}: ContactMessageDetailsSectionProps) {
  const paragraphs = (body ?? "")
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);
  const visibleItems = items.map((item) => item.trim()).filter(Boolean);

  if (!title.trim() && !paragraphs.length && !visibleItems.length) return null;

  return (
    <section className="mb-20 max-w-4xl md:mx-auto mx-5" aria-label={title}>
      <div className="px-6 sm:px-14">
        {title.trim() ? (
          <h2 className="text-2xl font-bold text-[#F5F5F5]">{title}</h2>
        ) : null}

        {paragraphs.length ? (
          <div className="mt-10 space-y-8 text-lg leading-7 text-[#F5F5F5]/90">
            {paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        ) : null}

        {listTitle?.trim() || visibleItems.length ? (
          <div className="mt-12">
            {listTitle?.trim() ? (
              <h3 className="text-xl font-bold text-[#F5F5F5]">{listTitle}</h3>
            ) : null}
            {visibleItems.length ? (
              <ul className="mt-6 list-disc space-y-1 pl-6 text-md leading-7 text-[#F5F5F5]/90 marker:text-[#F5F5F5]">
                {visibleItems.map((item, index) => (
                  <li key={`${item}-${index}`} className="pl-1">
                    {item}
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}
